import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { CourseAssignee, CourseAssigneeCompletionStatus } from './getCourseAssignees';

export type CourseTeamAssignee = {
   avatar: string;
   teamid: number;
   team_name: string;
   total_stages: number;
   members_count: number;
   completed_stages: number;
   members_completed: number;
   members?: CourseAssignee[];
   time_allotted: number | null;
   team_assignment_date: number | null;
   status: CourseAssigneeCompletionStatus;
};

export type CourseTeamAssigneesOptions = {
   page?: number;
   limit?: number;
   search?: string;
};

export type CourseTeamAssigneesResponse = {
   response: Array<CourseTeamAssignee>;
   hasMore: boolean;
   totalAssignees: number;
};

export async function getCourseTeamAssignees(
   wikiid: number,
   options?: CourseTeamAssigneesOptions,
   common: CommonRequestOptions = {}
): Promise<CourseTeamAssigneesResponse> {
   const { page = 1, limit = 10 } = options ?? {};

   let queryParams = `page=${page}&limit=${limit}`;
   queryParams += options?.search ? `&search=${options.search}` : '';

   return await makeRequest('get', `course_assignees/course/${wikiid}/teams?${queryParams}`, {
      ...common,
   });
}
